import { useState } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Badge } from './badge'
import { Button } from './button'
import { JournalStats } from '@/gql/graphql'

const STATUS_LABELS: Record<string, string> = {
  NEW: 'Új',
  IN_PROGRESS: 'Folyamatban',
  PROBLEMS: 'Problémás',
  DONE: 'Készen van',
  APPROVED: 'Jóváhagyva',
  SENT: 'Kiküldve',
}

interface JournalStatProps {
  value: JournalStats
  className?: string
}

export function JournalStat({ value, className }: JournalStatProps) {
  const [open, setOpen] = useState(false)
  const total = value.statuses.reduce((sum, s) => sum + s.count, 0)

  return (
    <div
      className={cn(
        'rounded-xl border bg-card text-card-foreground shadow px-3 py-2 text-sm w-fit',
        className,
      )}
    >
      <div className="flex items-center gap-2">
        <span className="font-medium">
          {value.journal.issueYear}/{value.journal.issueNumber}
        </span>
        <Badge variant="secondary">{total}</Badge>
        <Button
          variant="ghost"
          size="icon"
          className="ml-auto h-6 w-6"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <ChevronUp /> : <ChevronDown />}
        </Button>
      </div>
      {open && (
        <ul className="mt-2 space-y-1 border-t pt-2">
          {value.statuses.map((s) => (
            <li key={s.status} className="flex items-center gap-2">
              <span className="text-xs text-muted-foreground">
                {STATUS_LABELS[s.status] ?? s.status}
              </span>
              <Badge variant="outline" className="ml-auto text-xs">
                {s.count}
              </Badge>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
